/** PLT 转 PDF 对外路径（非显而易见，避免被随意访问） */
export const PLT_CONVERTER_ROUTE_PATH = '/p/cz8k4m2x'

export const PLT_CONVERTER_ROUTE_NAME = 'pltConverter'

/** 管理后台内 PLT 转 PDF（顶部导航入口） */
export const PLT_CONVERTER_APP_ROUTE_PATH = '/app/plt-converter'

export const PLT_CONVERTER_APP_ROUTE_NAME = 'pltConverterApp'
